import { action, makeObservable } from 'mobx';
import { createContext, useContext } from 'react';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import { redirectToRoute } from 'routes/redirectToRoute';
import IGroupCensusReviewPageStore from 'store/modules/census/group-based/iGroupCensusReviewPageStore';

interface DomainProps {
  groupId: string;
  enrollmentPeriodId: string;
  cartId: string;
}
export default class CensusReviewPageStore extends IGroupCensusReviewPageStore {
  protected _domainData;
  private _cartId: string;

  // Needed for common census components
  public onBackRedirect(): void {
    redirectToRoute(QuoteRouteV2Id.QUOTE_ADD_EMPLOYEES_CENSUS_UPLOAD, {
      groupId: this._domainData.groupId,
      periodId: this._domainData.enrollmentPeriodId,
      cartId: this._cartId,
    });
  }

  public onCompleteRedirect(): void {
    redirectToRoute(QuoteRouteV2Id.QUOTE_ADD_EMPLOYEES, {
      groupId: this._domainData.groupId,
      periodId: this._domainData.enrollmentPeriodId,
      cartId: this._cartId,
    });
  }

  constructor(domainData: DomainProps) {
    super();

    this._domainData = domainData;
    this._cartId = domainData.cartId;
    makeObservable<CensusReviewPageStore>(this, {
      onBackRedirect: action.bound,
      onCompleteRedirect: action.bound,
    });
  }
}

const QuoteChecklistCensusReviewPageStoreContext = createContext(new CensusReviewPageStore({} as DomainProps));

export const useQuoteChecklistCensusReviewPageStore = (): CensusReviewPageStore => {
  return useContext(QuoteChecklistCensusReviewPageStoreContext);
};

export { QuoteChecklistCensusReviewPageStoreContext };
